module.exports = __webpack_public_path__ + "img/top-image2.e1b62f6d.png";